module.exports = __webpack_public_path__ + "img/inconvo-logo-black-without-o.5061c89d.svg";